export default {};
throw new Error(`Could not resolve "gsap/ScrambleTextPlugin" imported by "@appletosolutions/reactbits". Is it installed?`)